import { HttpClient } from "../http";
import type { InstagramAccount } from "../types";

interface AccountsResponse {
  accounts: InstagramAccount[];
  limits: {
    maxAccounts: number;
    currentAccounts: number;
  };
}

export class InstagramService extends HttpClient {
  constructor() {
    super(process.env.NEXT_PUBLIC_API_URL!);
  }

  async getAccounts() {
    const response = await this.get<AccountsResponse>("/api/instagram/accounts");
    return {
      ...response,
      data: response.data?.accounts ?? null,
    };
  }

  async disconnectAccount(accountId: string) {
    return this.delete<{ success: boolean }>(`/api/instagram/accounts/${accountId}`);
  }

  async toggleAccount(accountId: string) {
    return this.patch<InstagramAccount>(`/api/instagram/accounts/${accountId}/toggle`);
  }

  async getConnectUrl() {
    const response = await this.post<{ url: string }>("/api/instagram/connect", {});
    return { url: response.data?.url ?? null, error: response.error, status: response.status };
  }

  async refreshUsername(accountId: string) {
    return this.post<InstagramAccount>(`/api/instagram/accounts/${accountId}/refresh-username`, {});
  }
 
  async refreshWebhook(accountId: string) {
    return this.post<{ success: boolean; message: string; verified: boolean; fields: string[] }>(`/api/instagram/accounts/${accountId}/refresh-webhook`, {});
  }

  async getWebhookStatus(accountId: string) {
    return this.get<{ subscribed: boolean; fields: string[] }>(`/api/instagram/accounts/${accountId}/webhook-status`);
  }
}
